import {
  jb_print_icon_css_default
} from "./chunk.Z5C6LYNK.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/icons/jb-print-icon/jb-print-icon.ts
var JbPrintIcon = class extends Icon(i) {
  render() {
    return b`
      <svg
        fill="currentColor"
        viewbox="0 0 22 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 11.12H4v3.75c0 .138.112.25.25.25h13.5a.25.25 0 0 0 .25-.25zm-4.316-7.686h3.303L13.684.935zm4.542.938l-.333-.252H13.57a.575.575 0 0 1-.57-.58V.929H3.774V6.12h14.452zM.25 15.12c-.138 0-.25-.097-.25-.217V6.337c0-.12.112-.217.25-.217H3V.631C3 .35 3.22.12 3.49.12h10.276c.104 0 .204.034.288.097l4.744 3.59c.127.096.202.25.202.414V6.12h2.75c.138 0 .25.097.25.217v8.566c0 .12-.112.217-.25.217H19v.743c0 .142-.12.257-.267.257H3.267A.262.262 0 0 1 3 15.863v-.743zm.75-8v7h2v-3.743c0-.142.12-.257.267-.257h15.466c.148 0 .267.115.267.257v3.743h2v-7z"
        ></path>
      </svg>
    `;
  }
};
JbPrintIcon.styles = [reset_css_default, jb_print_icon_css_default];
JbPrintIcon = __decorateClass([
  customElement("jb-print-icon")
], JbPrintIcon);

export {
  JbPrintIcon
};
